import React from 'react'
import ReactApexChart from "react-apexcharts";
import HeaderTitle from '../../CopyPeopleList/HeaderTitle'
function Copiers() {


    const state = {

        series: [{
            name: "STOCK ABC",
            data: [31, 40, 28, 51, 42, 109, 100]
        }],
        options: {
            chart: {
                type: 'area',
                height: 350,
                zoom: {
                    enabled: false
                }
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                 // lineCap: 'butt',
                 colors: undefined,
                 width: 1,
                 dashArray: 0
            },

            title: {
                text: '',
                align: 'left'
            },
            subtitle: {
                text: '',
                align: 'left'
            },
            labels: [1, 28, 42, 51, 60, 109, 120],
            xaxis: {
                type: 'datetime',
            },
            yaxis: {
                opposite: true
            },
            legend: {
                horizontalAlign: 'left'
            }
        },


    };


    return (
        <div id="Copiers" style={{width: "50%"}}>
             <HeaderTitle title="Copiers" dir="ltr" />
            <ReactApexChart options={state.options} series={state.series} type="area" height={200} />
        </div>
    )
}

export default Copiers
